export default function PrivacyTerms() {
  return <h2>Privacy Policy & Terms</h2>;
}
